import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#050B2E] text-white py-4 px-6" data-id="element-78">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2" data-id="element-79">
        <div className="text-sm" data-id="element-80">© 2025 Shotcraft Golf</div>
        <div className="flex gap-6 text-sm" data-id="element-81">
          <a href="https://www.shotcraftgolf.com/terms-of-service" className="text-[#8B96B4] hover:text-white transition-colors" data-id="element-82">
            Terms of Use
          </a>
          <a href="https://www.shotcraftgolf.com/privacy" className="text-[#8B96B4] hover:text-white transition-colors" data-id="element-83">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>;
}